import { forwardRef } from "react";
function SvgRawPlusIcon({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      fill="none"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10Zm4.5 0a1 1 0 0 1 1-1H9V5.5a1 1 0 1 1 2 0V9h3.5a1 1 0 1 1 0 2H11v3.5a1 1 0 1 1-2 0V11H5.5a1 1 0 0 1-1-1Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawPlusIcon);
export default ForwardRef;
